// import RouletteHandler from './common/RouletteHandler';
import React from 'react';
import BetslipConf from './data/betslip/BetslipConf';
import BonusConf from './data/betslip/BonusConf';
import UserConf from './data/betslip/UserConf';
import CashoutConfigurationCtx from './data/cashout/CashoutConfigurationCtx';
import ControlPanelConf from './data/control-panel-context/ControlPanelConf';
import FastbetConf from './data/fastbet/FastbetConf';
import LandingRequestedOpsConf from './data/landing/LandingRequestedOpsConf';
import ShopReceiptPrinterConf from './data/printer/ShopReceiptPrinterConf';
import TicketPrinterConf from './data/printer/TicketPrinterConf';
import PvrConf from './data/pvr/PvrConf';
import ShopConf from './data/shop/ShopConf';
import XRouterConf from './common/seo/xrouter/XRouterConf';
import { sectionFromXroutes, xSectionFromPath } from './common/seo/xrouter/seoUtils';
import XSeoConf from './common/seo/XSeoConf';
import { appConfig } from './appConfig';
import { getLabel } from './data/labels';
import AppModal from './data/modal/AppModal';
import { useEffect, useRef, useState } from 'react';
import BetOptionModalContentWrapper from './common/custom-modal/BetOptionModalContentWrapper';
import PurchaseResponseMessage from './data/betslip/PurchaseResponseMessage';
import BetslipVariation from './data/betslip/BetslipVariation';
import ProgressBarContainer from './data/progress-bar/ProgressBarContainer';
import { getQueryStringVariable } from './data/utils/getQueryStringVariable';

export const AppContext = React.createContext(null);

function App() {
    let container = null;
    switch (process.env.REACT_APP_FRONTEND_VERSION) {
        case 'betway': {
            container = React.lazy(() => import('./betway/Container'))
            break;
        }
        case 'starcasino': {
            container = React.lazy(() => import('./starcasino/Container'))
            break;
        }
        default: {
            container = React.lazy(() => import('./Container'));
            break;
        }
    }
    const [context, setContext] = useState({
	    Container: container,
	    update: function(updt) {
			// updating temporary
			for(let ko in updt) {
				const val = updt[ko];
				app.context[ko] = val;
			}
			//update effectly
			setContext(prev => {
                return {...prev, ...updt};
            });
        },

        showBetslipVariationModal: function (selections, advise, purchaseFunction, amountData, returnToBetslipFunction) {
			const betslipVariationData = {
					selections,
					advise,
					purchaseFunction,
					amountData,
					returnToBetslipFunction
			}
			this.update({betslipVariationData});
		},
		
		hideBetslipVariationModal: function() {
			const betslipVariationData = null;
			this.update({betslipVariationData});
		},

        showBetOptionsModal: function (options, type, checkedValue, selectorFunction, isBetclic) {
			const labelLeft = type === 'freebet'? 'betslip.freebet.title_part1' : 'betslip.fun_bonus.title_part1';
			const labelRight = type === 'freebet'? 'betslip.freebet.title_part2' : 'betslip.fun_bonus.title_part2';
			const modalHeader = [getLabel(labelLeft), getLabel(labelRight)].join(' ');
			const betOptionsData = {
					options,
					type,
					checkedValue,
					selectorFunction,
					modalHeader,
					isBetclic
			}
			app.context.update({betOptionsData});
		},
		
		hideBetOptionsModal: function() {
			const betOptionsData = null;
			app.context.update({betOptionsData});
		},
		showPurchaseMessageModal: function(message, type) {
			const purchaseResponseData = {
				message,
				type
			};
			app.context.update({purchaseResponseData});
		},
        hidePurchaseMessageModal: function () {
			const purchaseResponseData = null;
			app.context.update({purchaseResponseData});
		},
        showLivePurchaseProgressBar: function(duration, message) {
			const livePurchaseProgressBar = {
				duration: duration,
                message: message
			};
			this.update({livePurchaseProgressBar});
		},
        hideLivePurchaseProgressBar: function () {
			const livePurchaseProgressBar = null;
			this.update({livePurchaseProgressBar});
		},
    });
    
    const app = useRef({}).current;
    app.context = context;

    function addBodyClasses(){
        const body = document.getElementById('xs-mobile') || document.body;
        const isAppIOS = appConfig?.IS_APP_IOS || getQueryStringVariable('isAppIOS');
        const isAppAndroid = appConfig?.IS_APP_ANDROID || getQueryStringVariable('isAppAndroid');
        const className = isAppIOS?'xs-ios-wrapper':isAppAndroid?'xs-android-wrapper':'';
        if(body && className){
            if(!body.classList?.contains(className)){
                body.classList.add(className);
            }
        }
    }

    useEffect(() => {
        if (!window.showBetslipVariationModal) {
            window.showBetslipVariationModal = function(selections, advise, purchaseFunction, amountData, returnToBetslipFunction) {
               context.showBetslipVariationModal(selections, advise, purchaseFunction, amountData, returnToBetslipFunction);			
            }
        }
        
    	if (!window.showBetOptionsModal) {
            window.showBetOptionsModal = function(options, type, checkedValue, selectorFunction, isBetclic) {
               app.context.showBetOptionsModal(options, type, checkedValue, selectorFunction, isBetclic);			
            }
        }
        if (!window.hideBetOptionsModal) {
            window.hideBetOptionsModal = function() {
               app.context.hideBetOptionsModal();		
            }
        }
        if (!window.showModalPurchaseMessage) {
            window.showModalPurchaseMessage = function(message, type) {
               app.context.showPurchaseMessageModal(message, type);		
            }
        }

        if (!window.hideModalPurchaseMessage) {
            window.hideModalPurchaseMessage = function() {
               app.context.hidePurchaseMessageModal();		
            }
        }
        if (!window.showLivePurchaseProgressBar) {
            window.showLivePurchaseProgressBar = function(duration, message) {
               context.showLivePurchaseProgressBar(duration,message);		
            }
        }
        if (!window.hideLivePurchaseProgressBar) {
            window.hideLivePurchaseProgressBar = function() {
               context.hideLivePurchaseProgressBar();		
            }
        }
        addBodyClasses();
    }, []);

    window.testProgressBar = function(duration,message) {
        window.showLivePurchaseProgressBar(duration || 5000, message || 'Test progressbar');
    }

    function findSection(pathname) {
        try {
            section = xSectionFromPath(pathname,appConfig.ROUTES['prematch']) || xSectionFromPath(pathname,appConfig.ROUTES['live']) || sectionFromXroutes(pathname);
            return section;
        } catch(err) {
            console.log(err);
        }
    }
    
    const pathname = window.location.pathname;
    var section = findSection(pathname);
    
    const Container = app.context.Container;    
    return (
        <AppContext.Provider value={app.context}>
            <XSeoConf>
                <LandingRequestedOpsConf section={section} findSection={findSection} pathname={pathname} reloadTimeout={100} >
                    <ShopReceiptPrinterConf>
                        <ShopConf>
                            <CashoutConfigurationCtx>
                                <PvrConf>
                                    <UserConf frontendVersion="mobile_2">
                                        {/* <RouletteHandler></RouletteHandler> */}
                                        <ControlPanelConf>
                                            <TicketPrinterConf>
                                                <FastbetConf>
                                                    <BonusConf>
                                                        <BetslipConf>
                                                            {app.context.betOptionsData &&
                                                                <AppModal
                                                                    closeFunction={()=>{app.context.hideBetOptionsModal()}}
                                                                    uncloseable={false}
                                                                    modalHeader={app.context.betOptionsData.modalHeader}
                                                                    isMobile={true}
                                                                    modalContent={<BetOptionModalContentWrapper betOptionsData={app.context.betOptionsData}
                                                                    closeFunction={()=>{app.context.hideBetOptionsModal()}}/>}
                                                                />
                                                            }
                                                            {app.context.betslipVariationData && 
                                                                <AppModal
                                                                    uncloseable={true}
                                                                    modalHeader={getLabel('carrello.var_quota.warning')}
                                                                    modalContent={<BetslipVariation
                                                                    betslipVariationData={app.context.betslipVariationData}
                                                                    closeFunction={()=>{app.context.hideBetslipVariationModal()}} />}
                                                                />
                                                            }
                                                            {context.purchaseResponseData && 
                                                                <AppModal
                                                                    uncloseable={app.context.purchaseResponseData?.type === 'acceptance'}
                                                                    modalHeader={getLabel('general.message')}
                                                                    modalContent={<PurchaseResponseMessage purchaseResponseData={app.context.purchaseResponseData} />}
                                                                    closeFunction={()=>{context.hidePurchaseMessageModal()}}
                                                                />
                                                            }
                                                            {app.context.livePurchaseProgressBar && 
                                                                <AppModal
                                                                    uncloseable={true}
                                                                    transparentBackdrop={true}
                                                                    modalHeader={context.livePurchaseProgressBar.message}
                                                                    modalContent={<ProgressBarContainer duration={context.livePurchaseProgressBar.duration} downward={true} />}
                                                                />
                                                            }
                                                            <XRouterConf>
                                                                <Container />
                                                            </XRouterConf>
                                                        </BetslipConf>
                                                    </BonusConf>
                                                </FastbetConf>
                                            </TicketPrinterConf>
                                        </ControlPanelConf>
                                    </UserConf>
                                </PvrConf>
                            </CashoutConfigurationCtx>
                        </ShopConf>
                    </ShopReceiptPrinterConf>
                </LandingRequestedOpsConf>
            </XSeoConf>
        </AppContext.Provider>
    );
}

export default App;
